import Request from '@/api/request';
import { StatementType } from '@/types/services';
import { IdentityDocument } from '@/api/identityDocuments';

const api = new Request('lk/');

export interface ICurrency {
  code: string;
  title: string;
}

export interface GetDisclaimerResponse {
  id: number;
  message?: string;
  statementType: StatementType;
}

export function getCurrency(): Promise<ICurrency[]> {
  return api.get('getCurrency');
}

export function getLanguages(): Promise<string[]> {
  return api.get('getLanguages');
}

export function getDisclaimer(
  statementType: StatementType
): Promise<GetDisclaimerResponse> {
  return api.get('getDisclaimer', {
    params: {
      statementType,
    },
  });
}

export function getIdentityDocumentsRod(): Promise<IdentityDocument[]> {
  return api
    .get('getIdentityDocumentsRod')
    .then((documents: IdentityDocument[]) => {
      return documents;
    });
}

export function getIdentityDocumentsNoticeRecovery(): Promise<
  IdentityDocument[]
> {
  return api.get('getIdentityDocumentsNoticeRecovery');
}
